import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer, Cell, LineChart, Line
} from 'recharts';
const barColors = ["#8B0000",
"#A52A2A",
"#B22222",
"#DC143C",
"#FF0000",
"#FF6347",
"#FF7F50",
"#CD5C5C",
"#F08080",
"#E9967A",
"#FA8072",
"#FFA07A",
"#FF4500",
"#FF8C00",
"#FFA500",
"#FFD700",
"#B8860B",
"#DAA520",
"#EEE8AA",
"#BDB76B",
"#F0E68C",
"#808000",
"#FFFF00",
"#9ACD32",
"#556B2F",
"#6B8E23",
"#7CFC00",
"#7FFF00",
"#ADFF2F",
"#006400",
"#008000",
"#228B22",
"#00FF00",
"#32CD32",
"#90EE90",
"#98FB98",
"#8FBC8F",
"#00FA9A",
"#00FF7F",
"#2E8B57",
"#66CDAA",
"#3CB371",
"#20B2AA",
"#2F4F4F",
"#008080",
"#008B8B",
"#00FFFF",
"#00FFFF",
"#E0FFFF",
"#00CED1",
"#40E0D0",
"#48D1CC",
"#AFEEEE",
"#7FFFD4",
"#B0E0E6",
"#5F9EA0",
"#4682B4",
"#6495ED",
"#00BFFF",
"#1E90FF",
"#ADD8E6",
"#87CEEB",
"#87CEFA",
"#191970",
"#000080",
"#00008B",
]
class ComplianceBarchart extends PureComponent {
  static propTypes = {
    data: PropTypes.arrayOf(PropTypes.shape({
      Banco: PropTypes.string,
      Afiliaciones: PropTypes.number,
      Meta: PropTypes.number
    })).isRequired,
  }


	render () {
  	return (
      <ResponsiveContainer height={300} width='100%'>
        <LineChart
          width='100%'
          height={300}
          data={this.props.data}
          // layout="horizontal"
          margin={{top: 20, left: -10}}>
          {/*<CartesianGrid strokeDasharray="1 1"/>*/}
          <XAxis dataKey="Banco" interval={0}
                 tick={{fontSize: 10}}
                 tickLine={false}
                 tickMargin={20}
          />
          <YAxis />
          <Tooltip/>
          <Legend />
          <Line dataKey="Afiliaciones" stackId="a" stroke="#82ca9d" />
          <Line dataKey="Meta" stackId="a" stroke="#8884d8" />

        </LineChart>
      </ResponsiveContainer>
    );
  }
}

export default ComplianceBarchart;
